const fbEvents = {
  COMPLETE_REGISTATION: 'CompleteRegistration',
  PAGE_VIEW: 'PageView',
  PURCHASE: 'Purchase',
};

export const fbCompleteRegistration = () => {
  if (window?.fbq) {
    window.fbq('track', fbEvents.COMPLETE_REGISTATION);
  }
};

export const fbPurchase = (amount) => {
  if (window?.fbq) {
    window.fbq('track', fbEvents.PURCHASE, { currency: 'EUR', value: amount });
  }
};
